import { render, staticRenderFns } from "./BottomCard.vue?vue&type=template&id=8b136548&scoped=true&"
import script from "./BottomCard.vue?vue&type=script&lang=js&"
export * from "./BottomCard.vue?vue&type=script&lang=js&"
import style0 from "./BottomCard.vue?vue&type=style&index=0&id=8b136548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b136548",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBottomSheet,VBtn,VCard,VIcon})
